import mainLogo from '../../images/Estilo/Estilo_logo_color.png';
import squareLogo from '../../images/Estilo/Estilo_logo_color.png';
import bannerLogoWhite from '../../images/Estilo/Estilo_logo_branco.png';
import banner01 from '../../images/Estilo/Estilo_BG_01.jpg';
import banner02 from '../../images/Estilo/Estilo_BG_03.jpg';
import banner03 from '../../images/Estilo/Estilo_BG_04.jpg';
import banner04 from '../../images/Estilo/Estilo_BG_02.jpg';
import car123 from '../../images/Estilo/123_jetta.jpg';
import box123 from '../../images/Estilo/123_Estilo.jpg';
import {SliderProducts} from '../../Utilities/SliderProducts';

export const configData = {
    defaultStore: 'Estilo',
    defaultStoreLink: 'pecasestiloautomoveis.com.br',
    defaultContactEmail: 'estoque@estilosautomoveis.com.br',
    whatsappNumber: '35 9904 3500',
    CNPJname: 'Estilo Automóveis LTDA',
    CNPJ: '02.315.552/0001-14',
    CNPJaddress: 'R ANTONIO SCODELER, 285 - Pouso Alegre - MG - 37.550-001',
    launchDate: '12/02/2025',

    multiContact: {},
    searchByPlate: false,

    coupons: [
        // {
        //     coupon: '10PORCENTO',
        //     discountPrice: 0,
        //     discountPercent: 0.1,
        //     freeShipping: false,
        // },
        // {
        //     coupon: '10REAIS',
        //     discountPrice: 10,
        //     discountPercent: 0,
        //     freeShipping: false,
        // },
        // {
        //     coupon: 'FRETEGRATIS',
        //     discountPrice: 0,
        //     discountPercent: 0,
        //     freeShipping: true,
        // },
    ],

    brands: [
        'volkswagen',
    ],

    homologBrands: [
        'motorcraft',
        'motrio',
        'acdelco',
        'mopar',
        'bproauto',
    ],

    noVehicle: false,

    storeSellersWarehouses: [
        "ESTILO VW - POUSO ALEGRE", //"Concessionária Volkswagen - Pouso Alegre MG"
    ],

    disabledSellers: [],

    useMktNames: false,

    endYear: 2025,
    startYear: 1996,

    pixDiscount: 0.05,

    payment: {
        maxParcels: 6,
        checkoutParcels: {
            0: 1,
            200: 2,
            300: 3,
            600: 4,
            800: 5,
            1200: 6,
        }
    },

    customShipping: {
        deliveryTime: 1,
    },

    productSlider: [
        {
            name: 'Kits',
            img: 'tabKits',
            products: SliderProducts.Kits
        },
        {
            name: 'Óleos',
            img: 'tabOleos',
            products: SliderProducts.Oleos
        },
        {
            name: 'Filtros',
            img: 'tabFiltros',
            products: SliderProducts.Filtros
        },
        {
            name: 'Luzes',
            img: 'tabLuzes',
            products: SliderProducts.Luzes
        },
        {
            name: 'Acessórios',
            img: 'tabAcessorios',
            products: SliderProducts.Acessorios
        },
    ]
}

export const contentData = {
    mainLogo: mainLogo,
    squareLogo: squareLogo,
    bannerLogoWhite: bannerLogoWhite,

    banner01: banner01,
    banner02: banner02,
    banner03: banner03,
    banner04: banner04,
    bannerBrands: '',
    aboutUsBg: banner04,

    box123: box123,
    car123: car123,
    
    paymentImg: squareLogo,
    paymentImgMobile: squareLogo,

    bannerSpecial: '',
    bannerSpecialMobile: '',
    imgSepcial: '',
    imgSepcialMobile: '',

    bannerHighlight: 'Compre peças originais <span style="font-weight: bold;">Volkswagen</span> direto das concessionárias <span style="font-weight: bold;">Estilo</span>.',
    aboutUs: {
        title: 'Estilo Automóveis',
        content: [
            'Presente em Pouso Alegre desde 1998, a Estilo Automóveis sempre primou pelo trabalho sério e justamente por isso conquistou a confiança dos clientes e a posição de destaque neste competitivo mercado automobilístico. Ao longo do tempo, a empresa cresceu e contribuiu para a consolidação da bandeira Volkswagen na região.',
            'O objetivo da Estilo sempre foi a satisfação do seu cliente. E para que isso continue sendo seu diferencial, ela investe em treinamentos especializados em seus colaboradores, novas estratégias de mercado e sempre mantendo atualizada sua metodologia de trabalho. Se tornando uma das melhores concessionárias Volkswagen de Minas Gerais.',
            'Com a nova sede que passou a funcionar desde 05 de junho de 2013 a Estilo Automóveis, que é referência para 23 municípios da região, ganhou uma sede mais ampla e infraestrutura de qualidade para atender os clientes com conforto e agilidade.',
            'A nova estrutura é ideal para que a Estilo Automóveis coloque cada vez mais em prática o ATC (Atenção Total do Cliente). Trata-se de um programa que sistematiza e padroniza o atendimento de serviços da Rede Volkswagen com objetivo de garantir a satisfação aos seus clientes.',
        ],
        link: 'https://estiloautomoveis.com.br/institucional',
        linkCta: 'Saiba mais',
    },

    socialMedia: {
        Instagram: 'https://www.instagram.com/estiloautomoveispa/',
        Facebook: 'https://www.facebook.com/vwestilo/',
        LinkedIn: '',
        Youtube: '',
        Twitter: '',
    },

    footerContent: [],
}